<template>
    <div>
        <Panel :title="titleView"  style="margin:0px 1px; ">
            <Tabs style="height:540px">
                <TabPanel :title="'Personal Data'">
                    <fieldset class="c-fieldset">
                        <legend class="c-legend"><b>Data</b></legend>
                        <table width="50%" cellspacing="1" cellpadding="5" border="0">
                            <tbody>
                                <tr>
                                    <td style="width:10%;">
                                        Name
                                    </td>
                                    <td style="width:2%;">:</td>
                                    <td>
                                        <b>{{user.name}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Gender
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <b>{{user.gender_desc}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Phone
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <b>{{user.phone}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Email
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <b>{{user.email}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Contact Email
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <b>{{user.contact_email}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Created Date
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <b>{{user.created_date_desc}}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                    <fieldset class="c-fieldset">
                        <legend class="c-legend"><b>Access</b></legend>
                        <table width="50%" cellspacing="1" cellpadding="5" border="0">
                            <tbody>
                                <tr>
                                    <td style="width:10%;">
                                        Role
                                    </td>
                                    <td style="width:2%;">:</td>
                                    <td>
                                        <b>{{user.role_desc}}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                </TabPanel>
                <TabPanel :title="'Reset Password'">
                    <fieldset class="c-fieldset">
                        <legend class="c-legend"><b>Password</b></legend>
                        <Form ref="form" :model="password" :rules="rules" @validate="errors=$event">
                            <table width="30%" cellspacing="1" cellpadding="5" border="0">
                                <tbody>
                                    <tr>
                                        <td class="bg_subtitle">
                                            Old Password <font color="red">*</font>
                                        </td>
                                        <td class="bg_grid2"> 
                                            <PasswordBox inputId="old_password" name="old_password" class="f-field-text" v-model="password.old_password" placeholder="Old Password"></PasswordBox>
                                            <div class="error">{{textError.old_password}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg_subtitle">
                                            New Password <font color="red">*</font>
                                        </td>
                                        <td class="bg_grid2"> 
                                            <PasswordBox inputId="new_password" name="new_password" class="f-field-text" v-model="password.new_password" placeholder="New Password"></PasswordBox>
                                            <div class="error">{{textError.new_password}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg_subtitle">
                                            Confirm Password <font color="red">*</font>
                                        </td>
                                        <td class="bg_grid2"> 
                                            <PasswordBox inputId="confirm_password" name="confirm_password" class="f-field-text" v-model="password.confirm_password" placeholder="Confirm Password"></PasswordBox>
                                            <div class="error">{{textError.confirm_password}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bg_grid2" style="text-align: end;">
                                            <LinkButton :iconCls="iconUtil.iconSave" @click="onUpdatePassword()" :disabled="disableBtnSave" style="width:89px">{{ btnText.save }}</LinkButton>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Form>
                    </fieldset>
                </TabPanel>
            </Tabs>
        </Panel>

        <NotificationComponent ref="notification"></NotificationComponent>
    </div>
</template>

<script>
import UserManagementService from '@/services/UserManagementService';

import InformationUtil from '@/utils/InformationUtil';
import IconUtil from '@/utils/IconUtil';
import ModelUtil from '@/utils/ModelUtil';
import GlobalUtil from '@/utils/GlobalUtil';

import NotificationComponent from '@/components/NotificationComponent.vue';

export default {
    name: "UserProfileView",
    components: {
        NotificationComponent
    },
    data() {
        return {
            titleView : InformationUtil.userProfile + "s",
            iconUtil : IconUtil,
            user: {
                id : 0,
                name : "",
                email : "",
                role_id : "",
                role_desc : "",
                phone : "",
                language : "",
                image : "",
                gender : "",
                gender_desc : "",
                contact_email : "",
                created_date : "",
                created_date_desc : "",
            },
            password : {
                old_password: "",
                new_password: "",
                confirm_password: "",
            },

            btnText :{
                refresh : InformationUtil.refreshText,
                add : InformationUtil.addText,
                edit : InformationUtil.editText,
                delete : InformationUtil.removeText,
                save : InformationUtil.saveText,
                cancel : InformationUtil.cancelText,
                search : InformationUtil.searchText
            },
            disableBtnSave : false,

            // validation
            rules: {
                old_password: 'required',
                new_password: 'required',
                confirm_password: 'required',
            },
            errors: {},
            textError :{
                old_password : "",
                password : "", 
                confirm_password : ""
            },
        };
    },
    methods: {
        getError(name) {
            return this.errors[name] && this.errors[name].length
            ? this.errors[name][0]
            : null;
        },
        onUpdatePassword(){
            ModelUtil.resetModel(this.textError);
            this.$refs.form.validate((valid) => {
                if(!valid){
                    if(this.password.new_password != this.password.confirm_password){
                        this.textError.confirm_password = "Password and Confirm Password not match";
                        return;
                    }
                    
                    this.disableBtnSave = true;
                    this.password.id = this.user.id;
                    UserManagementService.post('/user/updatePassword', this.password)
                        .then(response => {
                            this.disableBtnSave = false;
                            if(response.code == 200){
                                GlobalUtil.removeWindow();
                                this.$store.dispatch('logout')
                                this.$router.replace({ name: 'login' })
                            }else{
                                this.$messager.alert({
                                        title: "Error",
                                        icon: "error",
                                        msg: response.message
                                    });
                            }
                        }).catch(error => {
                            this.disableBtnSave = false;
                            this.$refs.notification.error(error);
                        });
                    
                } else {
                    for(let key in valid){
                        this.textError[key] = this.getError(key);
                    }
                }
            });
        }
    },
    mounted() {
        this.user.id = this.$store.getters.user.id;
        this.user.name = this.$store.getters.user.name;
        this.user.email = this.$store.getters.user.email;
        this.user.role_id = this.$store.getters.user.role_id;
        this.user.role_desc = this.$store.getters.user.role_desc;
        this.user.phone = this.$store.getters.user.phone;
        this.user.language = this.$store.getters.user.language;
        this.user.image = this.$store.getters.user.image;
        this.user.gender = this.$store.getters.user.gender;
        this.user.gender_desc = this.$store.getters.user.gender_desc;
        this.user.contact_email = this.$store.getters.user.contact_email;
        this.user.created_date = this.$store.getters.user.created_date;
        this.user.created_date_desc = this.$store.getters.user.created_date_desc;
    },
}
</script>